import { render } from "./TheAdminVideoShow.vue?vue&type=template&id=1fdd6bc4&scoped=true&ts=true"
import script from "./TheAdminVideoShow.vue?vue&type=script&lang=ts"
export * from "./TheAdminVideoShow.vue?vue&type=script&lang=ts"

import "./TheAdminVideoShow.vue?vue&type=style&index=0&id=1fdd6bc4&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdd6bc4"]])

export default __exports__